module.exports = __webpack_public_path__ + "static/media/step_21.05bbb86f.mp3";